var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.themes.base.concat(_vm.themes[_vm.theme]),attrs:{"href":_vm.href}},[(_vm.theme !== 'loading')?_vm._t("default"):[_vm._v("Loading")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }